import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { ANIMATION_TIMEOUT } from "./constants.js";
import { Notification } from "./Notification.js";
import Notification_module from "./Notification.module.js";
const AnimatedNotification = ({ notification, ...props })=>{
    const nodeRef = useRef(null);
    const animationClasses = {
        enter: Notification_module.slideLeftEnter,
        enterActive: Notification_module.slideLeftEnterActive,
        exit: Notification_module.slideLeftExit,
        exitActive: Notification_module.slideLeftExitActive
    };
    return /*#__PURE__*/ jsx(CSSTransition, {
        ...props,
        classNames: animationClasses,
        timeout: {
            enter: ANIMATION_TIMEOUT,
            exit: ANIMATION_TIMEOUT
        },
        nodeRef: nodeRef,
        children: /*#__PURE__*/ jsx(Notification, {
            ref: nodeRef,
            ...notification
        })
    });
};
export { AnimatedNotification };
